import React, { useState } from "react"
import { useField, useFormikContext } from "formik"

import { getFormikFieldError } from "../../../../../../shared/components/createOrder/components/form/helpers"
import { useRequiredField } from "../../../../../../shared/components/forms/useRequiredField"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { ApiQueryAutocomplete } from "../../../../../../core/api/components/ApiQueryAutocomplete"
import {
    fetchServiceCenterResources,
    ServiceCenterHomeQuery,
    ServiceCenterResourcesResponse,
} from "../../../../../serviceCenter/report/home/serviceCenterHomeApi"
import { useAppSelector } from "../../../../../store/storeHooks"
import { selectEffectiveServiceCenterId } from "../../../../../context/contextSelectors"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

function transformData(data: ServiceCenterResourcesResponse) {
    return data.resources.map((room) => ({
        id: room.id,
        name: room.name,
    }))
}

export function DynamicRoomAutocomplete() {
    const serviceCenterId = useAppSelector(selectEffectiveServiceCenterId)
    const [open, setOpen] = useState(false)

    const [field, meta, helpers] = useField("room")
    const { submitCount } = useFormikContext<any>()
    const formikErrorProps = getFormikFieldError(meta, submitCount)
    const isRequired = useRequiredField("room")

    const {
        data: options = [],
        isError,
        isLoading,
    } = useApiQuery(fetchServiceCenterResources, {
        queryName: ServiceCenterHomeQuery.SERVICE_CENTER_RESOURCES,
        dependencies: {
            serviceCenterId: serviceCenterId ?? 0,
            type: "ROOM",
        },
        enabled: open && Boolean(serviceCenterId),
        select: transformData,
    })

    const handleChange = (_event: React.SyntheticEvent, value: any) => helpers.setValue(value)

    return (
        <LocalizedStrict id="devices-create-or-edit-form-select-field-room" attrs={{ label: true }}>
            <ApiQueryAutocomplete
                isLoading={open && isLoading}
                isError={isError}
                options={options}
                getOptionLabel={(option) => option.name || ""}
                value={field.value || null}
                onChange={handleChange}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                slotProps={{
                    textField: { ...formikErrorProps, InputLabelProps: { required: isRequired } },
                }}
                label="Room"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterOptions={(options, state) =>
                    options.filter(({ name }) => name.toLowerCase().includes(state.inputValue.toLowerCase()))
                }
            />
        </LocalizedStrict>
    )
}
